import { Partners } from '@shared/lib/partner'

interface GetXSystemIdArgs {
  partner: Partners
  isMembrana: boolean
  isWebView: boolean
  utmSource: boolean
  utmSourceLauncher: boolean
  isMtsDengi: boolean
  isTools: boolean
  isColizeum: boolean
  isFromPayment: boolean
  isMkSmsGames: boolean
}

export const getXSystemId = ({
  partner,
  isMembrana,
  isWebView,
  utmSource,
  utmSourceLauncher,
  isMtsDengi,
  isTools,
  isColizeum,
  isFromPayment,
  isMkSmsGames,
}: GetXSystemIdArgs) => {
  if (partner === Partners.CDEK) return 'cdek'
  if (partner === Partners.SMARTSHELL) return 'smartshell'
  if (partner === Partners.GLOBALTRADE) return 'globaltrade'
  if (partner === Partners.INTERVALE) return 'intervale'
  if (partner === Partners.CITORA) return 'citora_games'
  if (partner === Partners.PLATOSFERA) return 'platosfera-games'
  if (partner === Partners.WILDBERRIES) return 'wildberries-games'
  if (partner === Partners.WILDBERRIES2) return 'wildberries2-games'
  if (partner === Partners.VANTA) return 'vanta-games'
  if (partner === Partners.BANKIROS) return 'bankiros-games'
  if (partner === Partners.MEGAFON) return 'megafon-games'
  if (partner === Partners.GENBANK) return 'genbank-games'

  if (isMembrana && isWebView) return 'cyber-membrana'
  if (isWebView) return 'cyber-progressor'
  if (utmSource) return 'mymts'
  if (utmSourceLauncher) return 'launcher'
  if (isMtsDengi) return 'mtsdengi'
  if (isTools) return 'from_tools'
  if (isColizeum) return 'colizeum'
  if (isFromPayment) return 'payment-cyber'
  if (isMkSmsGames) return 'mksmsgames'

  return 'cyber'
}
